export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-lastfm-3a17efa32ab95fbdd6497edb0a76c9e2.svg";